import $Jq from "jquery";
export default function removeTopDivMore(content){
    var $html = $Jq(content);
    let html = "";
    if($html?.length > 1) {
        // 说明这个word文件没有最外层容器，可能是因为文件损坏了（可以尝试在word软件中另存一下，重新导入再试）
        return content
    }
    $Jq.each($html, function (i, el) {
        if(el.localName === "div") {
            // 去外层div
            html+=(el.innerHTML || '')
        } else {
            html+=(el.outerHTML || '')
        }
    });
    return html
}